module.exports = __webpack_public_path__ + "static/media/sketch_2.67721c68.jpg";